<template>
  <div class="setname">
    <div class="h1-title">请完善你的信息</div>
    <el-input v-model="form.name" placeholder="请输入昵称" maxlength="6" show-word-limit></el-input>
    <div class="sure"><el-button type="primary" @click="setUsername">确定</el-button></div>
  </div>
</template>

<script type="text/ecmascript-6">
  import userApi from '@/api/user'
  import userinfoApi from '@/api/userInfo'
  import axios from 'axios';
  import vue from 'vue';
  vue.prototype.$axios = axios;
  import qs from 'qs';
  vue.prototype.qs = qs;
export default {
  components: {

  },
  data () {
    return {
      callback:'',
      name: '',
      form: {
        id:0,
        name: '',
      },
      userInfo:{
        id:0,
        userId:0,
        userName:"",
      },
    }
  },
  mounted() {
    this.checkLogin();
    let url=window.location.href.substring(window.location.href.indexOf("callback"),window.location.href.length).replace("callback=","");

    this.callback=decodeURIComponent(url)
    console.log("callbacksetname",this.callback)
  },
  methods: {
    checkLogin(){
      let _this=this;
      let checkurl='/api/checkLogin?time='+new Date().getMilliseconds();
      _this.$axios.get(checkurl).then(function(result2){
        if(result2.data.isLogin){
          console.log(result2.data)
          _this.form.id=result2.data.casFastUserModel.id
          _this.name=result2.data.casFastUserModel.userName
          userinfoApi.selectUID(_this.form.id).then(reUserInfo => {
            _this.userInfo = reUserInfo.response
            // if(result2.data.casFastUserModel.userName!=result2.data.casFastUserModel.name){
            //   _this.$router.push({
            //     path:"/selecttype"
            //   })
            // }

          })
        }else{
          _this.$router.push({
            path:'/login',
          })
        }
      })
    },
    setUsername(){
      let _this = this
      if(_this.form.name.trim()==""){
        _this.$message.error("姓名不能为空")
        return false;
      }else{
        if(_this.form.name.trim().level>6){
          _this.$message.error("姓名长度不能超过6个字")
          return false;
        }
      }
      if(_this.form.name.trim()==_this.name){
        _this.$message.error("姓名不能为注册手机号")
        return false;
      }
          userApi.update(_this.form).then(data => {
            if (data.code === 1) {
              _this.userInfo.userName = _this.form.name
              userinfoApi.update(_this.userInfo).then(re =>{
                _this.$message.success(data.message)
                console.log("bbbbbbbbbbbbbbbbb")
                console.log(_this.callback)
                window.location.href =_this.callback
                // _this.$router.push({
                //   path:_this.callback
                // })
              })
            } else {
              _this.$message.error(data.message)
            }
          }).catch(e => {
          })
    }
  }
}
</script>

<style scoped lang="less">
.setname{
  margin: 0 auto;
  padding-top: @NAVHEIGHT + 40;
  padding-bottom: 40px;
  .h1-title{
    margin-bottom: 30px;
    text-align: center;
    color: #434343;
    font-size: 20px;
    font-weight: bold;
  }
  .sure{
    margin-top: 30px;
    text-align: center;
  }
}
@media screen and (max-width: 750px) {
  .setname{
    padding-left: 10px;
    padding-right: 10px;
  }
}
@media screen and (min-width: 751px) {
  .setname{
    width: 700px;
  }
}
</style>
